import React, { useState, useEffect } from 'react';
import Marquee from 'components/Core/Marquee';
import useBreakpointView from 'utils/useBreakpointView';
import { truncateText } from 'utils/text';
import { ArrowRightIcon, ArrowRightHoverIcon } from 'components/Brand/Icons';
import {
  CardsWrapperContainer,
  CardBodyContainer,
  FooterContainer,
  CategoryContainer,
} from './styles';

const CardsBodyWrapper = (WrappedCard) => {
  const WrappedComponents = (props) => {
    const {
      cta,
      ctaTitle,
      ctaLink,
      hovered,
      align,
      simpleResponsive = false,
      type,
      category,
      showFullDescription,
    } = props;

    return (
      <CardsWrapperContainer>
        <CardBodyContainer
          className={`${simpleResponsive ? 'simple-responsive' : ''} ${
            ctaTitle ? 'with-footer-cta' : ''
          } card-body--container`}
          align={align}
        >
          {category && <CategoryView {...{ category, hovered, simpleResponsive, ctaLink }} />}
          <WrappedCard
            {...props}
            {...(props.description && {
              description: showFullDescription
                ? props.description
                : truncateText(props.description, 175),
            })}
          />
          {cta ||
            (ctaTitle && (
              <FooterButton {...{ ctaTitle, hovered, align, simpleResponsive, type }} />
            ))}
        </CardBodyContainer>
      </CardsWrapperContainer>
    );
  };

  return WrappedComponents;
};

export default CardsBodyWrapper;

const CategoryView = ({ category, ctaLink, hovered, simpleResponsive }) => {
  const [showTicker, setShowTicker] = useState(false);
  const isMobile = useBreakpointView(['xs']);

  useEffect(() => {
    if (category.length > 28) {
      setShowTicker(ctaLink ? hovered || isMobile : false);
    }
  }, [hovered, isMobile]);

  if (React.isValidElement(category)) return category;

  const CategoryContent = (
    <CategoryContainer
      className={`${simpleResponsive ? 'simple-responsive' : ''} card-category`}
      hovered={ctaLink ? hovered || isMobile : false}
    >
      <p className="font-overline-sm">{category}</p>
    </CategoryContainer>
  );

  if (showTicker) {
    return <Marquee speed={30}>{CategoryContent}</Marquee>;
  }

  return CategoryContent;
};

const FooterButton = ({ ctaTitle, hovered, align, simpleResponsive, type }) => {
  return (
    <FooterContainer
      className={`${simpleResponsive ? 'simple-responsive' : ''} ${
        type === 'Icon' ? 'icon-card-footer' : ''
      }`}
      {...{ hovered, align }}
    >
      {ctaTitle}
      {hovered ? <ArrowRightHoverIcon /> : <ArrowRightIcon />}
    </FooterContainer>
  );
};
